<div class="lg:flex">

  <app-header />

  <main class="overflow-x-hidden">

    <app-search />

    <router-outlet *ngIf="searchService.searchResults() == null" />

    <app-search-results *ngIf="searchService.searchResults() != null" />

  </main>
</div>